import * as React from "react";

import { formatDate } from "app/utils/filters";
import BackOfficeAndSnapminLink from "app/components/BOComponents/BackOfficeAndSnapminLink";
import SnapminLink from "app/components/BOComponents/SnapminLink";
import { ColumnConfig } from "app/components/AppComponents/ConfigurableTable";
import { FraudStatusIcon } from "app/components/AppComponents/Fraud";

const columnConfigs: ColumnConfig[] = [
  {
    name: "Date",
    render: row => formatDate(row.created_at)
  },
  {
    name: "App version",
    render: row => row.app_version
  },
  {
    name: "Build version",
    render: row => row.build_version
  },
  {
    name: "Build type",
    render: row => row.build_type
  },
  {
    name: "Platform",
    render: row => row.platform
  },
  {
    name: "Platform version",
    render: row => row.platform_version
  },
  {
    name: "Token",
    render: row => row.token
  },
  {
    name: "Device fraud status",
    render: row => (
      <FraudStatusIcon fraudStatus={row.device_only_fraud_status} />
    )
  },
  {
    name: "First name",
    render: row => row.first_name
  },
  {
    name: "Surname",
    render: row => row.surname
  },
  {
    name: "Model",
    render: row => row.model
  },
  {
    name: "Name",
    render: row => row.name
  },
  {
    name: "User agent",
    render: row => row.user_agent
  },
  {
    name: "Phone number",
    render: row => (
      <BackOfficeAndSnapminLink
        backofficeUrl={`/snapscan/ops/devices/${
          row.external_reference
        }/summary`}
        snapminUrl={row.snapmin_url}
      >
        {row.phone_number || "-"}
      </BackOfficeAndSnapminLink>
    )
  },
  {
    name: "Snapmin",
    render: row => <SnapminLink snapminUrl={row.snapmin_url} />
  },
  {
    name: "Status",
    render: row => row.status
  },
  {
    name: "User",
    render: row => (
      <BackOfficeAndSnapminLink
        backofficeUrl={`/snapscan/ops/users/${
          row.user.external_reference
        }/payments`}
        snapminUrl={row.user.snapmin_url}
      >
        {row.user.email}
      </BackOfficeAndSnapminLink>
    )
  }
];

export default columnConfigs;
